import { Injectable, ComponentFactoryResolver, ApplicationRef, Injector, EmbeddedViewRef, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { CommonStringsComponent } from '@portal-core/i18n/components/common-strings/common-strings.component';

@Injectable({
  providedIn: 'root'
})
export class I18nService {
  private commonStrings: Dictionary<string>;

  constructor(
    @Inject(DOCUMENT) private document: Document,
    private componentFactoryResolver: ComponentFactoryResolver,
    private injector: Injector,
    private applicationRef: ApplicationRef
  ) {
    /*
     * Creates the CommonStringsComponent and inserts it into the DOM to then extract the translated strings from it.
     * These strings are then saved to be used by the consumers of this service.
     * This is done because Angular internationalization occurs only within templates. This brings the strings from the template into code.
     */
    const factory = this.componentFactoryResolver.resolveComponentFactory(CommonStringsComponent);
    const componentRef = factory.create(this.injector);

    const componentRootElement = (componentRef.hostView as EmbeddedViewRef<any>).rootNodes[0] as HTMLElement;
    this.applicationRef.attachView(componentRef.hostView);
    componentRef.onDestroy(() => this.applicationRef.detachView(componentRef.hostView));

    const commonStringsComponent = componentRef.instance as CommonStringsComponent;
    commonStringsComponent.ready.subscribe(commonStrings => {
      this.commonStrings = commonStrings;
      componentRef.destroy(); // Destroy the component now that the strings have been extracted
    });

    this.document.body.appendChild(componentRootElement);
  }

  getString(name: string): string {
    return this.commonStrings ? this.commonStrings[name] : undefined;
  }
}
